import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface ScrollToTopWrapperProps {
  children: React.ReactNode;
  scrollToHeight?: number; // Optional height prop (default: 70)
  smoothScroll?: boolean; // Optional smooth behavior (default: true)
}

export const ScrollToTopWrapper = ({
  children,
  scrollToHeight = 70, // Default height if not provided
  smoothScroll = true,
}: ScrollToTopWrapperProps) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: scrollToHeight,
      behavior: smoothScroll ? "smooth" : "auto",
    });
  }, [pathname, scrollToHeight, smoothScroll]);

  return <>{children}</>;
};
